import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractSecondaryToolbar } from '../../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { AbstractSensorContentState2D } from '../../state/abstract-sensor-content-state-2d';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';
import { KeypointTool } from './keypoint-tool';

@Component({
  selector: 'h3-keypoint-secondary-toolbar',
  templateUrl: './keypoint-secondary-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KeypointSecondaryToolbarComponent extends AbstractSecondaryToolbar<
  AbstractSensorContentState2D,
  AbstractSensorContentStore2D,
  KeypointTool
> {}
